import React, { useState, useEffect } from "react";
import "./Services.css";
import { FaPhoneAlt, FaCalendarAlt } from "react-icons/fa"; // ✅ Import icons

export default function Services() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const services = [
    {
      title: "Occupational Therapy (OT)",
      image: "/occupational.png",
      fullText: [
        "Building skills for everyday success through play-based activities.",
        "We help with:",
        "• Fine and gross motor skills",
        "• Balance and coordination",
        "• Sensory support",
        "• Visual perceptual and motor integration",
        "• Independence in self-care",
        "• Handwriting & classroom readiness",
      ],
    },
    {
      title: "Speech & Language Therapy",
      image: "/speech.png",
      fullText: [
        "Helping children communicate with confidence and clarity.",
        "We help with:",
        "• Vocabulary & sentence formation",
        "• Clarity of speech",
        "• Social communication",
        "• Feeding & swallowing support",
        "• Gestures/assistive devices",
      ],
    },
    {
      title: "Behavioural Therapy",
      image: "/behaviour.png",
      fullText: [
        "Creating positive behaviours and emotional balance.",
        "We support:",
        "• Tantrum & aggression management",
        "• Attention & focus",
        "• Social skills & emotional regulation",
        "• Behaviour intervention plans",
        "• Toilet training & routines",
      ],
    },
    {
      title: "Physiotherapy",
      image: "/physio.png",
      fullText: [
        "Helping children move freely and confidently.",
        "We assist with:",
        "• Milestones (rolling, crawling, walking)",
        "• Gait & posture training",
        "• Strength & balance",
        "• Orthotics & mobility aids",
        "• Rehabilitation for cerebral palsy & neurological conditions",
      ],
    },
    {
      title: "Special Education & Remedial Teaching",
      image: "/specialEdu.png",
      fullText: [
        "Turning challenges into learning opportunities.",
        "We provide:",
        "• Customized IEPs",
        "• Academic readiness",
        "• Reading, writing & math support",
        "• Visual & auditory strategies",
        "• Attention & memory building",
      ],
    },
    {
      title: "Child Psychology",
      image: "/psychology.png",
      fullText: [
        "Understanding the child behind the behaviour.",
        "We help with:",
        "• Developmental & psychological assessments",
        "• Autism & ADHD evaluations",
        "• Emotional support & therapy",
        "• Play therapy",
        "• Parent counselling",
      ],
    },
    {
      title: "Additional Family Support",
      image: "/additionalFamSupp.png",
      fullText: [
        "Supporting you because you're part of the journey.",
        "We offer:",
        "• Parent training & workshops",
        "• School readiness programs",
        "• Group therapy & social play",
        "• Home therapy programs",
        "• Sibling & family support",
      ],
    },
    {
      title: "Advanced Physiotherapy",
      image: "/advancedPhysio.png",
      fullText: [
        "Comprehensive physiotherapy care for adults of all ages — to reduce pain, improve mobility, and restore function.",
        "We offer:",
         "• General & Sports Physiotherapy",
        "• Hand Therapy with Custom Splinting",
        "• Podiatry with Medical-Grade Orthotics",
        "• Ergonomics Assessment",
        "• Shockwave Therapy",
        "• Dry Needling",
        "• Dynamic Taping",
        "• Massage Therapy",
        "• Strength & Conditioning Training",
      ],
    },
  ];

  // Set browser tab title
    useEffect(() => {
      document.title = "Services | Gifted Child Therapy";
    }, []);

  return (
    <div className="services-page">
      {/* Banner */}
      <header className="services-header text-center">
        <div className="services-banner-wrapper">
          <img
            src="/servicesTitle.png"
            alt="Our Services"
            className="services-banner-img"
          />
          <h1 className="services-heading">Our Services</h1>
        </div>
        <p className="services-subtitle">
          Helping Your Child Grow, Learn, and Shine
        </p>
      </header>

      {/* Service Cards */}
      <div className="container my-5">
        <div className="row justify-content-center">
          {services.map((service, index) => (
            <div
              className="col-12 col-sm-6 col-lg-4 mb-4 d-flex justify-content-center"
              key={index}
            >
              <div
                className={`service-card shadow-sm d-flex flex-column ${
                  expandedIndex === index ? "expanded" : ""
                }`}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="service-img"
                />
                <div className="service-card-body flex-grow-1">
                  <h3>{service.title}</h3>
                  <div className="service-full-text">
                    {service.fullText.map((line, i) => (
                      <p key={i}>{line}</p>
                    ))}
                  </div>
                </div>
                <button
                  className="service-toggle-btn mt-auto"
                  onClick={() => toggleExpand(index)}
                >
                  {expandedIndex === index ? "Read Less ▲" : "Read More ▼"}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action Section */}
      <section className="cta-section text-center py-5 bg-light">
        <div className="container">
          <h2 className="mb-3">Ready to Begin?</h2>
          <p className="lead mb-4">
            Whether your child needs just one service or a full therapy plan,
            we're here to help. At <strong>The Gifted Child</strong>, we create
            a customized program that fits your child’s unique gifts and
            challenges—with love, patience, and care.
          </p>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <a href="tel:+911122334455" className="btn btn-primary btn-lg">
              <FaPhoneAlt className="me-2" /> Book an Assessment Today
            </a>
            <a href="/contact" className="btn btn-outline-secondary btn-lg">
              <FaCalendarAlt className="me-2" /> Contact Our Team
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
